/* eslint-disable */

export const composeValidators = (...validators) => (value) =>
  validators.reduce((error, validator) => error || validator(value), undefined)
export const required = (value) => (value ? undefined : 'Ce champs est requis')
export const mustBeEmail = (value) =>
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value,
  )
    ? undefined
    : 'Ce champs doit etre un e-mail'
export const mustBeNumber = (value) =>
  window.isNaN(value) ? 'Doit etre un nombre' : undefined

export const mustContainSpecialChar = (value) =>
  /[!@#$%^&*(),.?":{}|<>_\-\+]/.test(value)
    ? undefined
    : 'Doit contenir un charactère spécial'

export const mustBeLongerThan = (minLength) => (value) =>
  ((value?.length > minLength) || value == '')
    ? undefined
    : `Doit contenir plus de ${minLength} charactères`
export const mustContainUpperCase = (value) =>
  /[A-Z]/.test(value) ? undefined : 'Doit contenir un charactère en majuscule'
export const mustContainlowerCase = (value) =>
  /[a-z]/.test(value) ? undefined : 'Doit contenir un charactère en minuscule'

export const mustBePassword = (value) => {
  const error = composeValidators(
    mustBeLongerThan(6),
    mustContainSpecialChar,
    mustContainUpperCase,
    mustContainlowerCase,
  )(value)
  return error ? `Le mot de passe ${error.toLowerCase()}` : undefined
}

export const mustBeConfirmPassword = (password) => (value) =>
  value === password
    ? undefined
    : 'La confirmation doit etre identique au mot de passe'

export const mustBePhoneNumber = (value) =>
/^(2135|2136|2137)[1-9]{1}[0-9]{7}$/.test(value)
  ? undefined
  : 'Doit être un numéro de téléphone ex: 213550112233'